import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const recruitmentRoutes = [
  {
    page: MainPage,
    path: pathRoutes.recruitment.base,
    screenCode: SCREEN.IP_024,
  },
  {
    page: MainPage,
    path: pathRoutes.recruitment.parameter,
    screenCode: SCREEN.IP_024,
  },
  {
    page: MainPage,
    path: pathRoutes.recruitment.detail.parameter,
    screenCode: SCREEN.IP_024,
  },
];
